import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export interface CartTotal {
  quantity: number;
  price: number;
}

export const userSelector = createSelector(
  (state: AppState) => state.user,
  s1 => s1.user
);

export const deliveryDeliveryAddressesSelector = createSelector(
  (state: AppState) => state.user,
  userState => {
    let deliveryAddresses = [...userState.user.deliveryAddresses];
    deliveryAddresses = deliveryAddresses.sort((a, b) => {
      if (!a.deliveryTerminal) {
        return 1;
      }
      if (!b.deliveryTerminal) {
        return -1;
      }
      return 0;
    });
    return deliveryAddresses
  }
);
